<template>
  <section id="section__why">
    <v-row no-gutters class="landing-container" style="max-width: 414px">
      <v-col cols="1"></v-col>
      <v-col cols="11">
        <p class="ma-0 font--m-1">번개입금 서비스!</p>
      </v-col>

      <v-col cols="4"></v-col>
      <v-col cols="8">
        <p class="ma-0 font--m-1 text-center">
          <span class="font-size--35" style="color: #f45e4a">왜</span>
          써야 할까요?
        </p>
      </v-col>
    </v-row>

    <v-row no-gutters class="landing-container">
      <v-col cols="12" class="mt-10">
        <p v-for="(comment, index) in comments" :key="`cm-${index}`" class="why-comment">
          <img src="@/assets/images/icons/check--pink.svg" />
          <span v-html="comment"></span>
        </p>
      </v-col>
    </v-row>

    <p class="text-center font--m-2 mb-0" style="line-height: 1.5; margin-top: 3rem">
      하루
      <span class="font--m-2 font-weight-black" style="color: #f45e4a">135원</span>
      <span class="font--m-5">(일 매출 50만원 기준)</span>
      으로 <br />
      바로 해결하세요!
    </p>
  </section>
</template>

<script>
export default {
  data() {
    return {
      comments: [
        '내 카드 매출, 배달 매출을 왜 늦게 받아야 하지?',
        '주말 매출도 바로 받을 수는 없을까?',
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
#section__why {
  background-color: white;
  padding: 5rem 12px !important;

  .why-comment {
    background-color: #f3f3f3;
    border-radius: 8px;
    font-weight: bold;

    margin-bottom: 35px;
    padding: 8px 12px;

    img {
      width: 22px;
      object-fit: contain;
      padding-right: 8px;
    }

    span {
      font-size: 15px;
    }
  }
}
</style>
